import { css } from "@emotion/css";

const styles = {
  modalContent: css`
    max-height: 70vh;
  `,
};

export default styles;
